module.exports = __webpack_public_path__ + "img/spin_on.fc5de903.png";